<template>
  <div>
    <p class="cm-mg-p-wzd text-center">
      2.1 {{ $t('common_words.calendar_companies_farm') }}
    </p>
    <hr />
    <div class="row">
      <select-component
        :dataOptions="businesses"
        :initialSelection="model.business_ids"
        :labelSelect="`${$t('common_words.associated_companies')}: *`"
        :requireClass="`required-businesses`"
        :rowClass="`col-12 col-md-6`"
        @onChange="handleChangeSelected"
        modelName="business_ids"
      />
      <select-component
        :dataOptions="filteredFarms"
        :initialSelection="model.farm_ids"
        :labelSelect="`${$t('common_words.associated_farms')}: *`"
        :requireClass="`required-farms`"
        :rowClass="`col-12 col-md-6`"
        @onChange="handleChangeSelected"
        modelName="farm_ids"
      />
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util.js';
import MixinForm from 'src/mixins/forms/mixin-form';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import SweetAlert from 'src/class/Alerts';

export default {
  data() {
    return {
      model: {
        business_ids: [],
        farm_ids: [],
        step: 2,
      },
      businesses: [],
      farms: [],
    };
  },
  mixins: [MixinPermissions, MixinForm, mixinMasters],

  watch: {
    '$i18n.locale': 'forceRerender',
  },

  computed: {
    filteredFarms() {
      if (
        !Array.isArray(this.model.business_ids) ||
        this.model.business_ids.length === 0
      ) {
        return [];
      }

      return this.concatAll(
        this.farms.filter((farm) => {
          if (!Array.isArray(farm.businesses)) return false;

          const farmBusinessIds = farm.businesses.map((b) => b.id);

          return this.model.business_ids.some((id) =>
            farmBusinessIds.includes(id)
          );
        })
      );
    },
  },

  methods: {
    handleChangeSelected(data) {
      this.$set(this.model, data.name, data.selects);

      if (data.name === 'business_ids') {
        const validFarmIds = this.filteredFarms.map((farm) => farm.id);

        // Filtra las fincas que aún pertenecen a las empresas seleccionadas
        this.model.farm_ids = this.model.farm_ids.filter((id) =>
          validFarmIds.includes(id)
        );
      }
    },

    validate() {
      return this.$validator
        .validateAll()
        .then((res) => {
          this.$emit('on-validated', res, {
            ...this.model,
            businessSelected: this.model.business_ids
              ? this.getNameSelected(this.model.business_ids, this.businesses)
              : null,
            farmsSelected: this.model.farm_ids
              ? this.getNameSelected(this.model.farm_ids, this.farms)
              : null,
          });

          return res;
        })
        .then((resp) => {
          if (!resp) return false;
          if (!isset(this.model.business_ids)) {
            return this.validationInputsRequired('businesses');
          } else if (!isset(this.model.farm_ids)) {
            return this.validationInputsRequired('farms');
          } else return true;
        });
    },
  },

  created() {
    if (this.isCreate() || this.isUpdate()) {
      this.showHideLoading(true);
      Promise.all([
        Axios.getMasters('businesses/only'),
        Axios.getMasters('farms/farms/'),
      ])
        .then(([responseBusiness, responseFarms]) => {
          this.businesses = this.concatAll(responseBusiness.data.data);
          this.farms = this.concatAll(responseFarms.data.data);

          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    let editForm = {};
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      editForm = JSON.parse(sessionStorage.getItem('editForm'));
      editForm.businesses.forEach((business) => {
        this.model.business_ids.push(business.id);
      });
      editForm.farms.forEach((farm) => {
        this.model.farm_ids.push(farm.id);
      });
    }
  },
};
</script>
